import styled from 'styled-components/native';

export const TabContainer = styled.View`
  padding-bottom: ${({ theme }) => theme.safeAreaInsets.bottom}px;
  flex-direction: row;
  background-color: ${({ theme }) => theme.color.base.c0};
  z-index: 9999;
`;
